/*! Oruga v0.8.12 | MIT License | github.com/oruga-ui/oruga */
import { _ as _sfc_main, a as _sfc_main$1 } from "./DropdownItem.vue_vue_type_script_setup_true_lang-Dpj7m-LI.mjs";
import { b as registerComponent } from "./config-C1k5NuG7.mjs";
const index = {
  install(app) {
    registerComponent(app, _sfc_main);
    registerComponent(app, _sfc_main$1);
  }
};
export {
  _sfc_main as ODropdown,
  _sfc_main$1 as ODropdownItem,
  index as default
};
//# sourceMappingURL=dropdown.mjs.map
